import React from 'react'
import {
  ModifyPlanBoxSummaryListItem,
  ModifyPlanBoxSummaryListItemName,
  ModifyPlanBoxSummaryListItemPrice,
} from 'Features/CrossSell/ModifyPlan/ModifyPlanBoxSummary/ModifyPlanBoxSummary.styled'
import { CURRENCIES } from 'Types/Currencies'
import { getAmountWithCurrency } from 'Utils/currencyHelper'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { CSS } from '@stitches/react'

type ModifyPlanBoxSummaryRowProps = {
  text: string
  amount: number | string
  outstanding?: boolean
  outstandingPrice?: boolean
  spaceAfter?: boolean
  css?: CSS
  isNegative?: boolean
}

export const ModifyPlanBoxSummaryRow = ({
  text,
  amount,
  outstanding,
  outstandingPrice,
  spaceAfter,
  css,
  isNegative,
}: ModifyPlanBoxSummaryRowProps) => {
  const { data } = useGetPlansDetails()
  return (
    <ModifyPlanBoxSummaryListItem css={css} outstanding={outstanding} spaceAfter={spaceAfter}>
      <ModifyPlanBoxSummaryListItemName outstanding={outstanding}>
        {text}
      </ModifyPlanBoxSummaryListItemName>
      <ModifyPlanBoxSummaryListItemPrice outstandingPrice={outstandingPrice}>
        {isNegative && '-'}
        {getAmountWithCurrency(data?.plans[0].currency || CURRENCIES.USD, undefined)}
        {amount.toLocaleString()}
      </ModifyPlanBoxSummaryListItemPrice>
    </ModifyPlanBoxSummaryListItem>
  )
}
